module.exports = __webpack_public_path__ + "img/32.73606f7f.png";